import React from "react";

interface PeakBrandMarkProps {
  /** White wordmark for use over the welcome video. */
  inverted?: boolean;
  enlarged?: boolean;
  className?: string;
}

/** "PEAK" in text-primary (white when inverted) + "^" always in brand blue, Space Grotesk Bold 22 (26.4 enlarged). */
const PeakBrandMark: React.FC<PeakBrandMarkProps> = ({ inverted = false, enlarged = false, className = "" }) => (
  <span
    className={`font-groteskLogo font-bold leading-none select-none ${enlarged ? "text-[26.4px]" : "text-[22px]"} ${className}`}
    aria-label="PEAK"
  >
    <span className={inverted ? "text-white" : "text-peak-text"}>PEAK</span>
    <span className="text-peak-brand">^</span>
  </span>
);

export default PeakBrandMark;

/** Renders "^" carets inside body copy with the wordmark font and brand blue, like iOS `onboardingCaretText`. */
export const CaretText: React.FC<{ text: string; caretClassName?: string }> = ({
  text,
  caretClassName = "font-groteskLogo font-bold text-peak-brand",
}) => {
  const parts = text.split("^");
  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index < parts.length - 1 && <span className={caretClassName}>^</span>}
        </React.Fragment>
      ))}
    </>
  );
};
